<template>
    <div class="box" :class="'box_' + type">
        <div class="badge" :class="'badge_' + type">
            {{ lang.related['estate_' + type + '_title'] }}
        </div>

        <div>
            <a :href="related_estate.detail_url">{{ related_estate.title }}</a>
        </div>

        <div class="related_estate_price">
            <a :href="related_estate.detail_url"><div v-html="related_estate.price" class="price"></div></a>
            <div v-if="related_estate.estate_other_contract" class="other_contract">
                <a :href="related_estate.estate_other_contract.detail_url">
                    {{ lang.labels.also }} {{ $root.lang.words.contract[related_estate.estate_other_contract.contract] }} 
                    <div class="detail_price">
                        <div v-html="related_estate.estate_other_contract.price"></div>
                        <masked-image src="/img/icons/linear-arrow-right.svg" class="costs-details" width="13" height="13"></masked-image>
                    </div>
                </a>
            </div>
        </div>

        <div class="estate-card-data">
            <div v-if="related_estate.rooms">
                <masked-image src="/img/icons/rooms.svg"></masked-image> {{ related_estate.rooms }}
            </div>
            <div v-if="related_estate.surface">
                <masked-image src="/img/icons/surface.svg"></masked-image>  {{ related_estate.surface }}
            </div>
            <div v-if="related_estate.bathrooms">
                <masked-image src="/img/icons/bathrooms.svg"></masked-image> {{ related_estate.bathrooms }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            related_estate: {
                type: Object,
                required: true,
            },

            type: {
                type: String,
                required: true,
            },
        },

        computed: {
            lang() {
                return this.$root.lang.estate_detail
            },
        },
    }
</script>